import React, { createRef, useState, useEffect, useContext } from "react";
import Dropzone from "react-dropzone";

import SharedThumbIcon from "../../images/upload-thumb-image.svg";
import InfoIcon from "../../images/InfoIconGray.svg";
import AddThumbImageIcon from "../../images/plus-icon.svg";
import DeleteIcon from "../../images/remove-icon.svg";
import "./SharedResource.scss";
import {
  uploadSharedFiles,
  deleteSharedFiles,
  geteDetailByID,
} from "../../services/apis";
import CloseIcon from "../../images/Close-Small.svg";
import SuccessIcon from "../../images/Success-Icon.svg";
import ErrorIcon from "../../images/Error-Icon.svg";
import CustomTooltip from "../../components/Tooltip/Tooltip";
import CircularProgressBar from "../../utils/CircularProgressBar";
import Addmore from "../../images/AddPlus-Icon-White.svg";
import { showErrorToast, showSuccessToast, showWarningToast } from "../toastComponent/ToastComponent";

const SharedImage = (props) => {
  const { deckId, setAllImages, deckData, editor } = props;
  const dropzoneRef = createRef();
  const [sharedImage, setSharedImage] = useState([]);
  const [deletedValue, setDeletedValue] = useState({});
  // const [isloading, setIsloading] = useState(true);

  useEffect(() => {
    setSharedImage(deckData?.deck_shared_assets?.images || []);
    setAllImages(deckData?.deck_shared_assets?.images || []);
    // getAllDetails();
  }, []);

  // const getAllDetails = () => {
  //     setIsloading(true);
  //     geteDetailByID(deckId, (response, err, errorCode) => {
  //         if(err) {
  //             console.log(err, 'error');
  //             setIsloading(false);
  //         } else {
  //             setIsloading(false);
  //             const data = response?.data?.deck_shared_assets?.images;
  //             setSharedImage(data);
  //         }
  //     });
  // }

  const onImageSelection = (accepted, rejected) => {
    const fontExt = ["image/png", "image/jpg", "image/jpeg"];
    const notAllowedFiles = accepted.filter(
      (file) => !fontExt.includes(file.type)
    );
    const filterExt = accepted?.filter((file) => fontExt?.includes(file.type));
    notAllowedWarn(notAllowedFiles);
    const formData = new FormData();

    if (filterExt.length > 10) {
      discardedExt(filterExt);
    }
    if (filterExt.length > 0) {
      let formDatalength = false;
      let bigFilesCount = 0;

      filterExt?.splice(0, 10)?.forEach((uploadFile) => {
        if (uploadFile.size <= 5242880) {
          formDatalength = true;
          formData.append("images", uploadFile);
        } else {
          bigFilesCount++;
        }
      });
      if (bigFilesCount > 0)
        toastErrorForBigImage(
          bigFilesCount,
          `${bigFilesCount} File${
            bigFilesCount > 1 ? "s" : ""
          } Upload unsuccessful,`
        );
      if (formDatalength) {
        // setIsloading(true);
        uploadSharedFiles(deckId, formData, (response, err, ErrorCode) => {
          if (err) {
            // setIsloading(false);
            toastErrorThrow(err.response.data.err[0].msg, "Upload");
          } else {
            // setIsloading(false);
            const data = response?.data?.response?.allImages;
            const failedFiles = response.data.err;
            setSharedImage(data);
            setAllImages(data);
            toastSuccesThrow("Uploaded Successfully");
            if (failedFiles.length > 0) toastErrorThrow(failedFiles, "Upload");
          }
        });
      }
    }
  };

  const deleteHandler = (list) => {
    setDeletedValue(list);
  };

  const deleteHandlerConfirmation = (value) => {
    if (value === "No") {
      setDeletedValue({});
    } else {
      const payloadObj = { list: deletedValue, deckId: deckId };
      // setIsloading(true);
      deleteSharedFiles(payloadObj, (response, err, ErrorCode) => {
        if (err) {
          // setIsloading(false);
          toastErrorThrow([], "Delete");
        } else {
          // setIsloading(false);
          const removed = sharedImage?.filter(
            (file) => file?.name !== deletedValue?.name
          );
          
          //<--- delete image from list and editor
          const deletedData =  sharedImage?.filter((file)=> file.name == deletedValue.name);
            const deletedImageNames = deletedData.map(item => item.name);

            props.editor.getWrapper().find('img').forEach(imgCmp => {
              const src = imgCmp.getAttributes().src;
              const fileName = src?.split('/').pop();

              if (deletedImageNames.includes(fileName)) {
                imgCmp.setAttributes({
                  src: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImZpbGw6IHJnYmEoMCwwLDAsMC4xNSk7IHRyYW5zZm9ybTogc2NhbGUoMC43NSkiPgogICAgICAgIDxwYXRoIGQ9Ik0yLjI4IDNMMSA0LjI3bDIgMlYxOWMwIDEuMS45IDIgMiAyaDEyLjczbDIgMkwyMSAyMS43MiAyLjI4IDNtMi41NSAwTDIxIDE5LjE3VjVhMiAyIDAgMCAwLTItMkg0LjgzTTguNSAxMy41bDIuNSAzIDEtMS4yNUwxNC43MyAxOEg1bDMuNS00LjV6Ij48L3BhdGg+CiAgICAgIDwvc3ZnPg==',
                  alt: 'ImageName'
                });
              }
            }); 
            // <---
         
          setSharedImage(removed);
          setAllImages(removed);
          setDeletedValue({});
          toastSuccesThrow("Deleted Successfully");
        }
      });
    }
  };

  const notAllowedWarn = (files) => {
    if (files.length > 0) toastWarnThrow(files);
  };
  const discardedExt = (files) => {
    showWarningToast(`${files.length - 10} file${files.length - 10 > 1 ? "s" : ""} are
        discarded, Only 10 files are allowed at a time`);
    // toast.warning(
    //   <div className="toast-text-message">
    //     {files.length - 10} file{files.length - 10 > 1 ? "s" : ""} are
    //     discarded, Only 10 files are allowed at a time
    //   </div>,
    //   {
    //     position: "top-right",
    //     autoClose: 5000,
    //     icon: <img className="toast-success-icon" src={SuccessIcon} />,
    //     hideProgressBar: true,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: false,
    //     closeButton: (
    //       <img className="toast-success-close-icon" src={CloseIcon} />
    //     ),
    //     progress: undefined,
    //     className: "toast-popup toast-info-popup shared-toast-popup-wrong-file",
    //   }
    // );
  };

  const toastErrorForBigImage = (failedFiles, action) => {
    showErrorToast(action, `${failedFiles.length > 0 && 'Cannot upload size of image more than 500Kb'}`);
    // toast.error(
    //   <div className="toast-text-message">
    //     <div className="toast-title error-msg">{action}</div>
    //     {failedFiles > 0 && (
    //       <div className="toast-title-msg">
    //         Cannot upload size of image more than 500Kb
    //       </div>
    //     )}
    //   </div>,
    //   {
    //     position: "top-right",
    //     autoClose: 5000,
    //     icon: (
    //       <img
    //         className={`toast-error-icon ${
    //           failedFiles?.length > 0 ? "align-img" : ""
    //         }`}
    //         src={ErrorIcon}
    //       />
    //     ),
    //     hideProgressBar: true,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: false,
    //     closeButton: (
    //       <img className="toast-success-close-icon" src={CloseIcon} />
    //     ),
    //     progress: undefined,
    //     className:
    //       "toast-popup toast-error-popup shared-toast-popup-wrong-file",
    //   }
    // );
  };

  const toastErrorThrow = (failedFiles, action) => {
    if(Array.isArray(failedFiles)) {
      showErrorToast(action, `${failedFiles.length > 0 && `${failedFiles.length}files failed to upload. Pl try again`}`);
    } else {
      showErrorToast(action, `${failedFiles} files failed to upload. Pl try again`);
    }
    // showErrorToast(action, `${failedFiles.length > 0 && `${failedFiles.length}files failed to upload. Pl try again`}`);
    // toast.error(
    //   <div className="toast-text-message">
    //     <div className="toast-title error-msg">{action} Unsuccessful</div>
    //     {failedFiles.length > 0 && (
    //       <div className="toast-title-msg">
    //         {failedFiles.length} files failed to upload. Pl try again
    //       </div>
    //     )}
    //   </div>,
    //   {
    //     position: "top-right",
    //     autoClose: 5000,
    //     icon: (
    //       <img
    //         className={`toast-error-icon ${
    //           failedFiles?.length > 0 ? "align-img" : ""
    //         }`}
    //         src={ErrorIcon}
    //       />
    //     ),
    //     hideProgressBar: true,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: false,
    //     closeButton: (
    //       <img className="toast-success-close-icon" src={CloseIcon} />
    //     ),
    //     progress: undefined,
    //     className:
    //       "toast-popup toast-error-popup shared-toast-popup-wrong-file",
    //   }
    // );
  };

  const toastSuccesThrow = (msg) => {
    showSuccessToast(msg);
  };

  const toastWarnThrow = (files) => {
    showWarningToast(`${files.length} files are discarded due to wrong Extension. Pl try
          again`,'Wrong file uploaded');

    // toast.warning(
    //   <div className="toast-text-message warning-toast">
    //     <div className="toast-title">Wrong file uploaded</div>
    //     <div className="toast-title-msg">
    //       {files.length} files are discarded due to wrong Extension. Pl try
    //       again
    //     </div>
    //   </div>,
    //   {
    //     position: "top-right",
    //     autoClose: 5000,
    //     icon: "",
    //     hideProgressBar: true,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: false,
    //     closeButton: (
    //       <img className="toast-success-close-icon" src={CloseIcon} />
    //     ),
    //     progress: undefined,
    //     className: "toast-popup toast-info-popup shared-toast-popup-wrong-file",
    //   }
    // );
  };

  return (
    <div className="shared-image">
      {/* {isloading && (
                <CircularProgressBar
                isloading={isloading}
                setIsloading={setIsloading}
                />
            )} */}
      <div
        className={`shared-image-main ${
          sharedImage?.length > 0 ? "" : "shared-image-main-added-border"
        }`}
      >
        <div className="upload-thumb-image-main" style={{ paddingBottom: 0 }}>
          <div className="upload-thumb-image-content">
            <div className="d-flex divAlignment">
              <h3 className="chooseFile">
                Image
              </h3>
              
                <CustomTooltip
                  classes="info-tooltip"
                  title="Add one or more images. Max 10 files can be uploaded together"
                  arrow
                >
                  <img
                    src={InfoIcon}
                    alt=""
                    className="upload-thumb-info-icon"
                  />
                </CustomTooltip>
              
            </div>

            {/*  */}
            {sharedImage?.length>0 && <Dropzone
              ref={dropzoneRef}
              multiple={true}
              accept=".png"
              onDrop={(accepted, rejected) =>
                onImageSelection(accepted, rejected)
              }
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()}>
                  <div className="add-thumb-Image">
                                      <input {...getInputProps()} />
                    <img src={Addmore} style={{ marginRight: "13px" }} />{" "}
                    <span>ADD</span>{" "}
                  </div>
                </div>
              )}
            </Dropzone>}
            {/*  */}
          </div>
        </div>
        {sharedImage?.length <= 0 ? (
          <div className="upload-thumb-image-main" style={{ paddingTop: 0 }}>
            <Dropzone
              ref={dropzoneRef}
              multiple={true}
              //maxFiles={10}
              accept="image/png"
              onDrop={(accepted, rejected) =>
                onImageSelection(accepted, rejected)
              }
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()} className="upload-file-section">
                  <input {...getInputProps()} />
                  <img
                    src={SharedThumbIcon}
                    width="12px"
                    height="12px"
                    className="upload-thumb-icon"
                  />
                  <span>ADD IMAGE</span>
                </div>
              )}
            </Dropzone>
          </div>
        ) : (
          <div className="uploaded-shared-main">
            
            <div className="custonScrollBar uploaded-shared-list">
              {sharedImage?.map((list) => (
                <div className="uploaded-shared font-details">
                  <div
                    className={`uploaded-shared-content d-flex justify-content-between align-items-center  ${
                      deletedValue?.name === list?.name
                        ? "added-border-bottom"
                        : ""
                    }`}
                  >
                    <div className="d-flex">
                      <img
                        className="uploaded-shared-content-image"
                        src={list?.link}
                        alt=""
                        width={24}
                        height={24}
                      />
                      <p className="uploaded-shared-name" title={list?.name}>
                        {list?.name.replace(/\.[^/.]+$/, "")}
                      </p>
                    </div>
                    <img
                      src={deletedValue?.name !== list?.name ? DeleteIcon : ""}
                      className="delete-uploaded-shared"
                      onClick={() => deleteHandler(list)}
                    />
                  </div>
                  {deletedValue?.name === list?.name ? (
                    <div className="delete-conformation-thumb-image">
                      <h2 className="delete-conformation-thumb-image-message">
                        The image to be deleted might have been used in slides.
                        <span>Are you sure?</span>
                      </h2>
                      <div className="d-flex justify-content-between">
                        <button
                          className="delete-conform-thumb-image-no btn btn-default"
                          onClick={() => deleteHandlerConfirmation("No")}
                        >
                          NO
                        </button>
                        <button
                          className="delete-conform-thumb-image-yes btn btn-default"
                          onClick={() => deleteHandlerConfirmation("Yes")}
                        >
                          YES, DELETE
                        </button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SharedImage;
